<script>
import MetisMenu from "metismenujs/dist/metismenujs";
import { menuItems } from "./menu";
import { mapState } from 'vuex';

export default {
  data() {
    return {
      menuItems: menuItems.filter((m) => m.active === '1'),
    };
  },
  computed: {
    ...mapState({
      pendingDeposits: state => state.notification.pendingDeposits,
      pendingWithDraws: state => state.notification.pendingWithDraws,
      user: state => state.auth.user,
    }),
  },
  mounted() {
    this.renderMenu();
  },
  methods: {
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    renderMenuLink(link) {
      const siteId = this.$route.params.site;
      return link.replace(':site', siteId)
    },
    renderMenu() {
      document.body.setAttribute("data-sidebar", "dark");
      // eslint-disable-next-line no-unused-vars
      var menuRef = new MetisMenu("#side-menu");
      var links = document.getElementsByClassName("side-nav-link-ref");
      var matchingMenuItem = null;
      for (var i = 0; i < links.length; i++) {
        if (window.location.pathname === links[i].pathname) {
          matchingMenuItem = links[i];
          break;
        }
      }

      if (matchingMenuItem) {
        matchingMenuItem.classList.add("active");
        let parent = matchingMenuItem.parentElement;

        if (parent) {
          parent.classList.add("mm-active");
          const parent2 = parent.parentElement.closest("ul");
          if (parent2 && parent2.id !== "side-menu") {
            parent2.classList.add("mm-show");

            const parent3 = parent2.parentElement;
            if (parent3) {
              parent3.classList.add("mm-active");
              var childAnchor = parent3.querySelector(".has-arrow");
              var childDropdown = parent3.querySelector(".has-dropdown");
              if (childAnchor) childAnchor.classList.add("mm-active");
              if (childDropdown) childDropdown.classList.add("mm-active");

              const parent4 = parent3.parentElement;
              if (parent4 && parent4.id !== "side-menu") {
                parent4.classList.add("mm-show");
                const parent5 = parent4.parentElement;
                if (parent5 && parent5.id !== "side-menu") {
                  parent5.classList.add("mm-active");
                  const childanchor = parent5.querySelector(".is-parent");
                  if (childanchor && parent5.id !== "side-menu") {
                    childanchor.classList.add("mm-active");
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};
</script>

<template>
  <div id="sidebar-menu">
    <ul id="side-menu" class="metismenu list-unstyled">
      <template v-for="(item, i) in menuItems">
          <li v-if="item.roles.includes(user.role)" :key="i">
            <a
                    v-if="hasItems(item)"
                    href="javascript:void(0);"
                    class="is-parent"
                    :class="{'has-arrow': !item.badge, 'has-dropdown': item.badge}"
            >
              <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
              <span>{{ item.label }}</span>
              <span v-if="item.icon === 'bx-transfer' && (pendingDeposits + pendingWithDraws) > 0" :class="`badge badge-pill badge-success float-right ml-2`">
                {{pendingDeposits + pendingWithDraws}}
              </span>

            </a>
            <router-link :to="item.link" v-if="!hasItems(item)" class="side-nav-link-ref">
              <i :class="`bx ${item.icon}`" v-if="item.icon"></i>
              <span>{{ item.label }}</span>
            </router-link>

            <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
              <template v-for="(subitem, index) of item.subItems" >
                <li v-if="subitem.roles.includes(user.role)" :key="index">
                  <router-link
                      :to="subitem.link"
                      v-if="!hasItems(subitem)"
                      class="side-nav-link-ref"
                  >{{ subitem.label }}
                    <span v-if="subitem.link === '/deposits' && pendingDeposits > 0" :class="`badge badge-pill badge-success float-right`">{{pendingDeposits}}</span>
                    <span v-if="subitem.link === '/withdrawals' && pendingWithDraws > 0" :class="`badge badge-pill badge-success float-right`">{{pendingWithDraws}}</span>
                  </router-link>
                  <a
                      v-if="hasItems(subitem)"
                      class="side-nav-link-a-ref has-arrow"
                      href="javascript:void(0);"
                  >{{ subitem.label }}</a>
                  <ul v-if="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                    <li v-for="(subSubitem, index) of subitem.subItems" :key="index">
                      <router-link
                          :to="subSubitem.link"
                          class="side-nav-link-ref"
                      >{{ subSubitem.label }}</router-link>
                    </li>
                  </ul>
                </li>
              </template>
            </ul>
          </li>
        </template>
    </ul>
  </div>
</template>
